import { IonIcon } from "@ionic/react";
import { ReactNode } from "react";
import { TYPE_PLA, SupportedDevices } from "./networking/NetTypes";

import capIcon from "img/capacity.svg";
import indIcon from "img/induction.svg";

function unreachable() {
	console.warn("Unreachable path reached");
	debugger;
}

export function SIPrefix(val: number) : { prefix: string, mult: number } {
	let log = Math.log10(Math.abs(val));
	if (isNaN(log) || -Infinity === log) log = 0;

	const oom = Math.floor(log / 3);

	if      (oom >=  3) return { prefix: "G", mult: 1e-9 };
	else if (oom <= -3) return { prefix: "n", mult: 1e+9  };

	switch (oom) {
	case  2: return { prefix: "M", mult: 1e-6 };
	case  1: return { prefix: "k", mult: 1e-3 };
	case  0: return { prefix: "" , mult: 1    };
	case -1: return { prefix: "m", mult: 1e+3 };
	case -2: return { prefix: "μ", mult: 1e+6 };
	default:
		unreachable();
		return { prefix: " ", mult: 1 };
	}
}

function Decompose(v : number) : { mantissa : number, pwr10 : number } {
  if (isNaN(v)) return { mantissa: NaN, pwr10: 1 };

  let sign = v < 0 ? -1 : 1;
  v = sign * v;

  if (v === Infinity) return { mantissa: sign, pwr10: Infinity };

  let exp = 1;
  while (v / exp >= 1) exp *= 10;

  return { mantissa: sign * v / exp, pwr10: exp }
}

export function Round(v: number) {
  const val = Decompose(v);
  return val.pwr10 * 1e-4 * Math.round(val.mantissa * 1e4);
}

// pc: počet platných cifer
export function FormatNumber(v: number, pc=3) {
	if (isNaN(v)) return "-";

	let sign = v < 0 ? -1 : 1;
	v = sign * v;

	const log = Math.log10(v);

	for (let i = 0; i < pc; i++) {
		if (log < i+1) return (sign * v).toFixed(pc-i);
	}
	return (sign * v).toFixed(0);
}

export function FormatNumberSI(v : number, compactSuffix = false, pc=3) {
  if (isNaN(v)) return "-";
  let sign = v < 0 ? -1 : 1;
  v = sign * v;
//v*=1e6;
  let suffix = compactSuffix ? "" : " ";
  if (v >= 1e3) {
    suffix = " k";
    v /= 1e3;
  }
  if (v >= 1e3) {
    suffix = " M";
    v /= 1e3;
  }
  if (v >= 1e3) {
    suffix = " G";
    v /= 1e3;
  }

  if (v < 10)
    return (sign * v).toFixed(pc) + suffix;
  if (v < 100)
    return (sign * v).toFixed(pc-1) + suffix;
  if (v < 1000)
    return (sign * v).toFixed(pc-2) + suffix;
  return (sign * v).toFixed(pc-3) + suffix;
}

export function UnscaledFormatNumber(v : number) {
  if (isNaN(v)) return "-";
  let sign = v < 0 ? -1 : 1;
  v = sign * v;

  if (v < 10)
    return (sign * v).toFixed(3);
  if (v < 100)
    return (sign * v).toFixed(2);
  if (v < 1000)
    return (sign * v).toFixed(1);
  return (sign * v).toFixed(0);
}

export function zfill(v : number) {
  return v.toString().padStart(2, "0");
}

export function JalFormat(val : number) {
  if (isNaN(val)) return "";

  if (val === 0) return "0.000 ";
  return <span style={{whiteSpace: "nowrap", marginLeft: "-4px"}}>
    <IonIcon icon={val > 0 ? indIcon : capIcon} style={{marginInline: "-1px"}} />
    &nbsp;{FormatNumber(Math.abs(val))}
  </span>
}

export function ModCosFormatPLA(val : number) {
  // v kapacite se |cos| zvetsi o 1
  if (isNaN(val)) return "";

  if (val === 0) return "0.000";
  let sign = val > 0 ? 1 : -1;
  val *= sign;
  if (val === 1) return "1.000"

  let cap = val * sign > sign;
  if (val > 1) val--;

  return <span style={{whiteSpace: "nowrap", marginLeft: "-4px"}}>
    <IonIcon icon={cap ? capIcon : indIcon} style={{marginInline: "-1px"}} />
    &nbsp;{FormatNumber(val)}
  </span>
}

export function ModCosFormatGCR(val : number) {
  // v kapacite se |cos| zvetsi o 1
  if (isNaN(val)) return "";

  if (val === 0) return "0.000";
  let sign = val > 0 ? 1 : -1;
  val *= sign;
  if (val === 1) return "1.000"

  let cap = val > 1;
  if (val > 1) val--;

  return <span style={{whiteSpace: "nowrap", marginLeft: "-4px"}}>
    <IonIcon icon={cap ? capIcon : indIcon} style={{marginInline: "-1px"}} />
    &nbsp;{FormatNumber(val)}
  </span>
}

export function SelectFormatter(type : string, device: SupportedDevices) : (val : number) => ReactNode {
  switch (type) {
		case "CosFi":
    case "CosFi_Mod":
    case "Pf_Mod":
      switch (device) {
      case TYPE_PLA: return ModCosFormatPLA;
      default: return ModCosFormatGCR;
      }
    default:
      return FormatNumber;
  }
}

